import React from 'react';
import styles from './styles.module.scss';
import classnames from 'classnames';
import icInfo from 'assets/svg/ic_info_outlined_V2.svg';
import icLinkOut from 'assets/svg/ic_link_out_gray.svg';
import trendUp from 'assets/svg/trend_up.svg';
import trendDown from 'assets/svg/trend_down.svg';
import bgStats from 'assets/img/bg_stake_stats.png';
import { useTypedSelector } from 'src/redux/utils';
import { formatCurrency, formatCurrencyInFiat } from '@wolffun/system-currency';
import { StakingPlan } from 'src/models';
import Tooltip from 'src/Pages/Staking/Components/Tooltip';

const StakeStats = ({
  className
}) => {
  const stats = useTypedSelector(state => state.stakingStats.data);
  const est = useTypedSelector(state => state.estimateApr.data);
  const {
    thgStaked,
    thgPrice,
    thgChangePercent,
    rewards,
    circulatingSupply
  } = stats || {};
  const {
    privateTickets,
    staking
  } = rewards || {};

  const renderTicketRewardTooltip = () => /*#__PURE__*/React.createElement(Tooltip, {
    color: "#3C32AF",
    content: /*#__PURE__*/React.createElement("div", {
      className: styles.tooltipContainer
    }, /*#__PURE__*/React.createElement("span", null, "Private Tickets issued is the total amount of receivable tickets over time, stakers can claim the tickets to join projects\u2019 private sales"))
  }, /*#__PURE__*/React.createElement("img", {
    src: icInfo
  }));

  const renderEstimatedRewardsTooltip = () => /*#__PURE__*/React.createElement(Tooltip, {
    color: "#282087",
    content: /*#__PURE__*/React.createElement("ul", {
      className: styles.tooltipList
    }, /*#__PURE__*/React.createElement("li", {
      className: classnames(styles.tooltipListItem, styles.active)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.itemTitle
    }, /*#__PURE__*/React.createElement("span", null, "High Rewards Stake - 12 Months"), /*#__PURE__*/React.createElement("div", {
      className: styles.badge
    }, /*#__PURE__*/React.createElement("span", null, "Best choice"))), /*#__PURE__*/React.createElement("div", {
      className: styles.itemPercentage
    }, /*#__PURE__*/React.createElement("span", null, "APR :\xA0"), /*#__PURE__*/React.createElement("span", {
      className: styles.value
    }, est[StakingPlan.ONE_YEAR], "%"))), /*#__PURE__*/React.createElement("li", {
      className: styles.tooltipListItem
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.itemTitle
    }, /*#__PURE__*/React.createElement("span", null, "High Rewards Stake - 6 Months")), /*#__PURE__*/React.createElement("div", {
      className: styles.itemPercentage
    }, /*#__PURE__*/React.createElement("span", null, "APR :\xA0"), /*#__PURE__*/React.createElement("span", {
      className: styles.value
    }, est[StakingPlan.SIX_MONTHS], "%"))), /*#__PURE__*/React.createElement("li", {
      className: styles.tooltipListItem
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.itemTitle
    }, /*#__PURE__*/React.createElement("span", null, "Flexible Stake")), /*#__PURE__*/React.createElement("div", {
      className: styles.itemPercentage
    }, /*#__PURE__*/React.createElement("span", null, "APR :\xA0"), /*#__PURE__*/React.createElement("span", {
      className: styles.value
    }, est[StakingPlan.FLEXIBLE], "%"))))
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.more
  }, /*#__PURE__*/React.createElement("span", null, "More info")));

  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.total
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, /*#__PURE__*/React.createElement("span", null, "Total Staked")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.totalTHG
  }, /*#__PURE__*/React.createElement("span", null, thgStaked && formatCurrency(thgStaked, {
    withCurrency: true,
    trimWholeFraction: true,
    precision: 0
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.totalUSD
  }, /*#__PURE__*/React.createElement("span", null, thgStaked && '$' + formatCurrencyInFiat(thgStaked, {
    withCurrency: false,
    trimWholeFraction: true,
    precision: 0
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.currentPrice
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.labelPrice
  }, "THG Price"), /*#__PURE__*/React.createElement("div", {
    className: styles.price
  }, /*#__PURE__*/React.createElement("span", null, "$", thgPrice && formatCurrency(thgPrice, {
    withCurrency: false,
    trimWholeFraction: true,
    precision: 2
  })), thgChangePercent && thgChangePercent !== -99999 && /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.trend, thgChangePercent != undefined && thgChangePercent >= 0 ? styles.trendUp : styles.trendDown)
  }, /*#__PURE__*/React.createElement("img", {
    src: thgChangePercent != undefined && thgChangePercent >= 0 ? trendUp : trendDown,
    className: styles.icTrend
  }), /*#__PURE__*/React.createElement("span", null, `${Math.abs(thgChangePercent || 0).toFixed(2)}%`)))))), /*#__PURE__*/React.createElement("div", {
    className: styles.estimate
  }, /*#__PURE__*/React.createElement("img", {
    src: bgStats,
    className: styles.bgStats
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, /*#__PURE__*/React.createElement("span", null, "Estimated Rewards")), /*#__PURE__*/React.createElement("div", {
    className: styles.planWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.plan
  }, /*#__PURE__*/React.createElement("span", null, "High Rewards Stake - 12 Months")), /*#__PURE__*/React.createElement("div", {
    className: styles.percentage
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.apr
  }, "APR"), /*#__PURE__*/React.createElement("span", {
    className: styles.number
  }, est[StakingPlan.ONE_YEAR], "%")), renderEstimatedRewardsTooltip()))), /*#__PURE__*/React.createElement("div", {
    className: styles.stats
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, /*#__PURE__*/React.createElement("span", null, "THG Stats")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.card
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Private Tickets Issued"), renderTicketRewardTooltip()), /*#__PURE__*/React.createElement("div", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("span", null, privateTickets && formatCurrency(privateTickets, {
    withCurrency: false,
    trimWholeFraction: true,
    precision: 0
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles.card
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Staking Rewards")), /*#__PURE__*/React.createElement("div", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("span", null, staking && formatCurrency(staking, {
    withCurrency: true,
    trimWholeFraction: true,
    precision: 0
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles.card
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Circulating Supply"), /*#__PURE__*/React.createElement("a", {
    href: "https://coinmarketcap.com/currencies/thetan-arena/",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    src: icLinkOut
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("span", null, circulatingSupply && formatCurrency(circulatingSupply, {
    withCurrency: true,
    trimWholeFraction: true,
    precision: 0
  })))))));
};

export default StakeStats;